import { render, staticRenderFns } from "./newRegisterTeacher.vue?vue&type=template&id=acbafd30&"
import script from "./newRegisterTeacher.js?vue&type=script&lang=js&"
export * from "./newRegisterTeacher.js?vue&type=script&lang=js&"
import style0 from "./newRegisterTeacher.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports